"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResourceService = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var ResourceService = exports.ResourceService = /*#__PURE__*/(0, _createClass2["default"])(function ResourceService() {
  (0, _classCallCheck2["default"])(this, ResourceService);
});
(0, _defineProperty2["default"])(ResourceService, "listPhonesRegions", function () {
  return _Api["default"]["default"]().get('/phone/regions');
});